import React from "react";
import { motion } from "framer-motion";

/**
 * PageHero - full-width hero with background image + dark overlay
 * Used on all sub-pages (NOT the home hero).
 */
const PageHero = ({ overline, title, subtitle, backgroundImage, minHeight = "min-h-[340px] sm:min-h-[420px] lg:min-h-[520px]", children }) => {
  return (
    <section
      className={`relative overflow-hidden border-b border-zinc-200 ${minHeight} flex items-center`}
      data-testid="page-hero"
    >
      {/* Background image */}
      <div className="absolute inset-0 z-0">
        <motion.img
          initial={{ scale: 1.08 }}
          animate={{ scale: 1 }}
          transition={{ duration: 1.4, ease: [0.16, 1, 0.3, 1] }}
          src={backgroundImage}
          alt=""
          className="w-full h-full object-cover"
          loading="eager"
        />
        {/* Dark gradient overlay for text readability */}
        <div className="absolute inset-0 bg-gradient-to-r from-zinc-950/85 via-zinc-950/70 to-zinc-950/40"></div>
        <div className="absolute inset-0 bg-gradient-to-t from-zinc-950/60 via-transparent to-transparent"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full py-14 sm:py-20 lg:py-28">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1], delay: 0.2 }}
          className="max-w-3xl"
        >
          {overline && (
            <span className="text-xs font-bold tracking-[0.2em] uppercase text-red-500">{overline}</span>
          )}
          <h1 className="mt-4 sm:mt-5 text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-display font-extrabold tracking-tighter text-white leading-[1.05]" data-testid="page-hero-title">
            {title}
          </h1>
          {subtitle && (
            <p className="mt-4 sm:mt-6 text-base sm:text-lg text-zinc-200 leading-relaxed max-w-2xl">{subtitle}</p>
          )}
          {children}
        </motion.div>
      </div>
    </section>
  );
};

export default PageHero;
